const {groupByEdition, resolveEdition, DEFAULT_EDITION} = require('./editions.cjs')

function parentKey(edition, id) {
  return JSON.stringify([edition, id])
}

function indexEditionParents(items = []) {
  const result = {}
  for (const item of items) {
    if (!item || !item.id) continue
    result[parentKey(resolveEdition(item.standard_set), item.id)] = item
  }
  return result
}

function editionParent(index, edition, id) {
  if (!id) return undefined
  const qualified = index[parentKey(edition, id)]
  if (qualified) return qualified
  // Unqualified legacy maps belong to 2014, never silently to 2022.
  return edition === DEFAULT_EDITION ? index[id] : undefined
}

function groupPlanningPdfStandards(items = [], teacherExpectations = {}, teacherStandards = {}) {
  return groupByEdition(items).map(edition => {
    const standards = []
    const byStandard = new Map()
    for (const item of edition.items) {
      const parent = item.expectation ? editionParent(teacherExpectations, edition.id, item.expectation) : item
      const expectation = parent || (item.expectation ? {
        id:item.expectation, standard:item.standard,
        name:item.expectation_name, description:item.expectation_description
      } : item)
      const expectationId = expectation.id || item.expectation || item.id
      const standardId = expectation.standard || item.standard || `unresolved:${expectationId}`
      let standard = byStandard.get(standardId)
      if (!standard) {
        const resolved = editionParent(teacherStandards, edition.id, standardId) || {}
        standard = {...resolved, id:standardId, name:resolved.name || item.standard_name, standard_set:edition.id, expectations:[]}
        byStandard.set(standardId, standard)
        standards.push(standard)
      }
      let entry = standard.expectations.find(value => value.id === expectationId)
      if (!entry) {
        entry = {...expectation, id:expectationId, standard_set:edition.id, indicators:[]}
        standard.expectations.push(entry)
      }
      if (item.expectation) entry.indicators.push({...item, standard_set:edition.id})
    }
    return {...edition, standards}
  })
}

module.exports = {parentKey, indexEditionParents, groupPlanningPdfStandards}
